

























import { Component, Vue } from 'vue-property-decorator';
import { AgencyModule } from '@/store/modules/agency';
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'


@Component({
	name: 'AgencyIndex',
  	components: {  Alert }
})
export default class extends GiganautVue {

	startSequence = "0";

    async index(path: string) {
        await AgencyModule.index(path + "?sequence=" + this.startSequence);
	}
}
